import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppSidebar from "../../components/AppSidebar";
import styles from "./styles.module.scss";
import { useQuery } from "@apollo/client";
import { GET_TIMEZONE_INFO } from "../../api/graphql/users";
import Header from "../../components/AppHeader";
import IntercomComponent from "../../components/Intercom";
import PaymentReturn from "../../components/PaymentReturn";
import InstallBanner from "../../components/InstallBanner";
import useIsPhone from "../../hooks/useIsPhone";

// On a phone the sidebar leaves the row: the top bar's menu button opens it
// as a drawer over the page, as in the admin panel.
const MainLayout = () => {
  const isPhone = useIsPhone();
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  // A picked page, or growing out of phone size, puts the drawer away.
  useEffect(() => setMenuOpen(false), [pathname, isPhone]);

  // On a phone the document itself scrolls and outlives the route: a new
  // page starts at its top, not where the last one was left.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const { data } = useQuery(GET_TIMEZONE_INFO);

  return (
    <>
      <div className={styles["container"]}>
        <AppSidebar
          drawer={isPhone ? { open: menuOpen, onClose: closeMenu } : undefined}
        />
        <div className={styles["main-content"]}>
          <div className={styles["dashboard"]}>
            <InstallBanner />
            <Header
              onMenu={isPhone ? () => setMenuOpen(true) : undefined}
              menuOpen={menuOpen}
            />
            <Outlet />
          </div>
        </div>
      </div>
      <IntercomComponent data={data?.getProfileTimezone} />
      <PaymentReturn />
    </>
  );
};

export default MainLayout;
